import React from "react";
import { Link } from 'react-router-dom'


const Configuarations = () => {
    return(
        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">


                    <div className="nodata comingroot">
                        <h2 className="comingsoon">Coming Soon...</h2>
                    </div>
                </div>
            </aside>
        </div>

    )
}

export default Configuarations;